import cLogo from '#themes/default/default/components/logo/logo.js';
import cSvg from '#themes/default/default/components/svg/svg.js';
import cTooltip from '#themes/default/default/components/tooltip/tooltip.js';

import template from './payPalBilling.html' with { type: 'html' };

export default {
	name: 'CPayPalBilling',
	components: {
		cLogo,
		cSvg,
		cTooltip
	},
	props: {
		order: {
			type: Object,
			default: () => null
		},
		theme: {
			type: Object,
			default: () => null
		}
	},
	computed: {
		brand() {
			return this.theme.brand;
		},
		logoDesign() {
			return 'light';
		}
	},
	template
};
